import { useCallback } from "react";
import { useAppSelector } from "./hooks";
import {
  selectAccountType,
  selectMemberExperienceData,
} from "../features/authentication/authenticationSlice";
import {
  selectIsInTrial,
  selectShowAccelerateBanner,
} from "../features/subscriptions/subscriptionSlice";

type SecondaryAccelerateHook = (
  reportType: "people" | "property" | "phone" | "social" | "vehicle",
) => boolean;
type UseSecondaryAccelerateHook = () => SecondaryAccelerateHook;

/* Secondary Accelerate Banner logic */

const useSecondaryAccelerateHook: UseSecondaryAccelerateHook = () => {
  const accountType = useAppSelector(selectAccountType);
  const isInTrial = useAppSelector(selectIsInTrial);
  const memberExperience = useAppSelector(selectMemberExperienceData);
  const showAccelerateBanner = useAppSelector(selectShowAccelerateBanner);
  const variant = memberExperience?.variant;
  const secondaryAccelerateHook = useCallback<SecondaryAccelerateHook>(
    (reportType: "people" | "property" | "phone" | "social" | "vehicle") => {
      let displayBanner = false;
      if (
        accountType !== reportType &&
        isInTrial &&
        variant === "m48" &&
        showAccelerateBanner
      ) {
        displayBanner = true;
      }
      return displayBanner;
    },
    [accountType, isInTrial, variant, showAccelerateBanner],
  );
  return secondaryAccelerateHook;
};

export { useSecondaryAccelerateHook };
